import { render, staticRenderFns } from "./ym-profit.vue?vue&type=template&id=68007552&scoped=true&"
import script from "./ym-profit.vue?vue&type=script&lang=js&"
export * from "./ym-profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68007552",
  null
  
)

export default component.exports